<script setup lang="ts">
import type { DirectSaleItemEntityWithPrice } from '~/types/directSale.type';

// PROPS
interface Props {
    directSale: DirectSaleItemEntityWithPrice;
}

const { directSale } = defineProps<Props>();

// MODEL
const offerAmount = defineModel<number>();

// COMPOSABLES
const { tt } = useTypedI18n();
</script>

<template>
    <template v-if="offerAmount !== undefined">
        <UFormField :label="tt('negotiation.yourInitialOffer')" class="text-base">
            <SalePriceStepper
                v-model="offerAmount"
                :min-bid-step-amount="directSale.minNegotiationStepAmount"
                :max-bid-step-amount="directSale.maxNegotiationStepAmount"
                :min-bid-step-amount-threshold="directSale.minNegotiationStepAmountThreshold"
                :min-value="directSale.minNegotiationOffer"
                :max-value="directSale.buyNowPrice"
            >
                <template #belowPrice>
                    <SaleFeesSimpleNotice is-buyer />
                </template>
            </SalePriceStepper>
        </UFormField>

        <SaleSuccessProbabilityIndicator :selected-amount="offerAmount" :reference-amount="directSale.buyNowPrice" mode="negotiationBuyer" />
    </template>
</template>
